import { APP_STATUS_TEXTS } from '@domain/integrations/app-catalog/app-catalog.constants';
import { TEXTS } from './integrations.constants';

// eslint-disable-next-line complexity
export const getIntegrationSubtitle = ({
    isDisabled,
    isSignInIntegration = false,
    isIntegrated = false,
    metadata,
}) => {
    if (metadata?.status) return APP_STATUS_TEXTS[metadata?.status] || APP_STATUS_TEXTS.unknown;
    if (isDisabled && !isSignInIntegration) return TEXTS.COMING_SOON;
    if (isIntegrated) return TEXTS.CONNECTED;
    if (isSignInIntegration) return TEXTS.SIGN_IN_INTEGRATION;

    return TEXTS.INTEGRATE_NOW;
};
